import { render, staticRenderFns } from "./only_button.vue?vue&type=template&id=3027ed15&scoped=true&"
import script from "./only_button.vue?vue&type=script&lang=js&"
export * from "./only_button.vue?vue&type=script&lang=js&"
import style0 from "./only_button.vue?vue&type=style&index=0&id=3027ed15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3027ed15",
  null
  
)

export default component.exports